<template>

    <m-edit1/>

    <m-update-site-message-1 v-bind='{...{},...{}}' :style='""' class="" ></m-update-site-message-1><m-loading-3 v-bind='{...{},...{}}' :style='""' class="" ></m-loading-3><m-div v-bind='{...{},...{}}' :style='""' class="nav-div" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   <m-nav-508 v-bind='{...{"hideDashboardLink":true,"megaMenuPosition":"blog_nav","megaMenuTitle":"\u0645\u0646\u0648","imageInsideSearchProp":"","showProfileLoginName":false,"dashboardLink":"https:\/\/paneldash.mixitweb.com\/dashboard\/","searchDirectPage":"search","hideShoppingCart":true,"menuPosition":"blog_nav","searchInput":"mSearchInput200"},...{}}' :style='""' class="" >
                <template #default>   <m-nav-sidebar-502 v-bind='{...{"menuPosition":"blog_nav"},...{}}' :style='""' class="d-inline-block" >
                <template #default>   <m-search-input-2 v-bind='{...{"directPage":"search"},...{}}' :style='""' class="" ></m-search-input-2></template>
                </m-nav-sidebar-502><m-span v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   <m-p v-bind='{...{},...{}}' :style='""' class="d-inline-block mx-1" >
                <template #default>منو   </template>
                </m-p></template>
                </m-span></template>
                </m-nav-508></template>
                </m-div></template>
                </m-div><router-view name='site' v-bind='{...{},...{}}' :style='""' class='""' />

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mUpdateSiteMessage1 from '@moeinmdn/miw-alpha-components/src/package/UpdateSiteMessage/UpdateSiteMessage1'; import mLoading3 from '@moeinmdn/miw-alpha-components/src/package/Loading/Loading3'; import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mNav508 from '@moeinmdn/miw-alpha-components/src/package/Navs/Nav508/Nav508'; import mNavSidebar502 from '@moeinmdn/miw-alpha-components/src/package/Navs/NavSidebar502/NavSidebar502'; import mSearchInput2 from '@moeinmdn/miw-alpha-components/src/package/Search/Input/SearchInput2'; import mSpan from '@moeinmdn/miw-alpha-components/src/package/Tags/Span'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P';

export default {
    name: 'HomeView',
    components: {mEdit1, mUpdateSiteMessage1,mLoading3,mDiv,mNav508,mNavSidebar502,mSearchInput2,mSpan,mP },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
